import { render, staticRenderFns } from "./newBoldCloseIcon.vue?vue&type=template&id=ffaf3c28&scoped=true"
import script from "./newBoldCloseIcon.vue?vue&type=script&lang=js"
export * from "./newBoldCloseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaf3c28",
  null
  
)

export default component.exports